module.exports = __webpack_public_path__ + "img/40_69_000_220.82596be5.jpg";